module.exports = __webpack_public_path__ + "img/multiple-users.f81ebf10.png";